// apps/web/lib/features/documents/shared/signing-link-format.ts
//
// The fragment form of a signing link: the bearer token after `#`, as
// /sign/w9#token=<token> or /sign/1099#token=<token>. Browsers never send a
// URL's fragment, so opening the link puts the token in no request line, no
// Referer and no Vercel request log; the page reads it client-side and hands
// it to the API in a POST body. Links carry the token in the path
// (/sign/w9/<token>) until lib/flags.ts `signingLinksTokenInFragment` is
// flipped (server/signing-link.ts); path links keep working either way.

/** The two signing pages: the W-9 ceremony and the 1099-NEC confirmation. */
export type SigningPageKind = "w9" | "1099";

/** The fragment parameter the token rides in. */
const TOKEN_PARAM = "token";

/** Which signing page a document request's link opens. */
export function signingPageKind(requestKind: string): SigningPageKind {
  return requestKind === "w9" ? "w9" : "1099";
}

/** A signing link's path and fragment: `/sign/w9#token=<token>`. */
export function signingLinkPath(page: SigningPageKind, token: string): string {
  return `/sign/${page}#${TOKEN_PARAM}=${encodeURIComponent(token)}`;
}

/** The token in a signing link's fragment (`#token=…`), or null without one. */
export function tokenFromSigningFragment(fragment: string): string | null {
  const token = new URLSearchParams(fragment.replace(/^#/, ""))
    .get(TOKEN_PARAM)
    ?.trim();
  return token === undefined || token === "" ? null : token;
}
